"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Message = require("../ui-components/Message");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable class-methods-use-this */
var Disabled = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Disabled, _Component);

  var _super = _createSuper(Disabled);

  function Disabled() {
    (0, _classCallCheck2.default)(this, Disabled);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Disabled, [{
    key: "setBodyClassName",
    value: function setBodyClassName() {
      var body = document.getElementsByTagName('body');
      body[0].classList.add('system-emails-disabled-message__show');
    }
  }, {
    key: "deleteBodyClassName",
    value: function deleteBodyClassName() {
      var body = document.getElementsByTagName('body');
      body[0].classList.remove('system-emails-disabled-message__show');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setBodyClassName();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deleteBodyClassName();
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _preact.h)(_Message.Message, {
        customClass: "system-emails-disabled-message",
        variant: "danger",
        text: (0, _preact.h)("div", null, "System emails have currently been paused, which mutes all automated emails (eg. replies, new topics, password resets, registration confirmations, etc.). You can resume emails in", ' ', (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/email/system-emails")
        }, "System Emails Settings"), ".")
      });
    }
  }]);
  return Disabled;
}(_preact.Component);

exports.default = Disabled;